import React from 'react';
import {IntlProvider, FormattedMessage, useIntl} from 'react-intl';

import {
  Table
} from 'react-lib/frameworks/Table'
import {
  FormGroup,
  FormField,
  Input
} from 'semantic-ui-react'
import {
  DateTextBox
} from 'react-lib/apps/common'

const CardEditDivisionSupplyOrderUX = (props: any) => {

    const isMounted = React.useRef(true);
    const intl = useIntl();

    React.useEffect(() => {
        return () => {
            isMounted.current = false;
        };
    }, []);


    return(
      <div
        id="CardEditDivisionSupplyOrderUX-div-0"
        style={{ height:"100%",padding:"10px"}}>
        <div
          className="ui form"
          id="CardEditDivisionSupplyOrderUX-div-1"
          style={{ marginBottom: "40px" }}>

          <FormGroup
            id="CardEditDivisionSupplyOrderUX-FormGroup-4"
            inline={true}>
            <FormField
              id="CardEditDivisionSupplyOrderUX-FormField-5"
              inline={true}>
              <div
                id="CardEditDivisionSupplyOrderUX-div-10"
                style={{ width: "100%", display: "flex", alignItems: "center", gap: "20px" } }>

                <label
                  id="CardEditDivisionSupplyOrderUX-label-15">
                  Date
                </label>
                <DateTextBox
                  id="CardEditDivisionSupplyOrderUX-DateTextBox-20"
                  onChange={props.onChangeDate}
                  value={props.searchSupplyOrder?.created_date || ""}>
                </DateTextBox>
              </div>
            </FormField>
            <FormField
              id="CardEditDivisionSupplyOrderUX-FormField-6"
              inline={true}>
              <div
                id="CardEditDivisionSupplyOrderUX-div-11"
                style={{ width: "100%", display: "flex", alignItems: "center", gap: "20px" } }>

                <label
                  id="CardEditDivisionSupplyOrderUX-label-16">
                  HN
                </label>
                <Input
                  id="CardEditDivisionSupplyOrderUX-Input-21"
                  name="hn"
                  onChange={props.onChangeData}
                  value={props.searchSupplyOrder?.hn || ""}>
                </Input>
              </div>
            </FormField>
            <FormField
              id="CardEditDivisionSupplyOrderUX-FormField-7"
              inline={true}>
              <div
                id="CardEditDivisionSupplyOrderUX-div-12"
                style={{ width: "100%", display: "flex", alignItems: "center", gap: "20px" } }>

                <label
                  id="CardEditDivisionSupplyOrderUX-label-17">
                  Code
                </label>
                <Input
                  id="CardEditDivisionSupplyOrderUX-Input-22"
                  name="code"
                  onChange={props.onChangeData}
                  value={props.searchSupplyOrder?.code || ""}>
                </Input>
              </div>
            </FormField>
            <FormField
              id="CardEditDivisionSupplyOrderUX-FormField-8"
              inline={true}>
              <div
                id="CardEditDivisionSupplyOrderUX-div-13"
                style={{ width: "100%" } }>

                <div
                  id="CardEditDivisionSupplyOrderUX-div-18">
                  {props.searchButton}
                </div>
              </div>
            </FormField>
            <FormField
              id="CardEditDivisionSupplyOrderUX-FormField-9"
              inline={true}>
              <div
                id="CardEditDivisionSupplyOrderUX-div-14"
                style={{ width: "100%" } }>

                <div
                  id="CardEditDivisionSupplyOrderUX-div-19">
                  {props.clearButton}
                </div>
              </div>
            </FormField>
          </FormGroup>
        </div>
        <div
          id="CardEditDivisionSupplyOrderUX-div-2">

          <Table
            className="--rt-tbody-overflow-y-hidden"
            columns={props.tableHeaders}
            data={props.supplyOrderList}
            id="CardEditDivisionSupplyOrderUX-Table-3"
            minRows="5"
            onPageChange={props.onPageChange}
            onPageSizeChange={props.onPageSizeChange}
            page={props.paginatedItems?.page || 0}
            pageSize={props.paginatedItems?.pageSize || 0}
            pages={Math.ceil(props.paginatedItems?.total / props.paginatedItems?.pageSize)}
            style={{ height: "calc(95vh - 14.5rem)"}}>
          </Table>
        </div>
        <div
          className="ui form"
          id="CardEditDivisionSupplyOrderUX-div-23"
          style={{ marginTop: "20px" }}>

          <FormGroup
            id="CardEditDivisionSupplyOrderUX-FormGroup-24"
            inline={true}
            style={{ justifyContent: "flex-end" }}>
            <FormField
              id="CardEditDivisionSupplyOrderUX-FormField-25"
              inline={true}>
              <div
                id="CardEditDivisionSupplyOrderUX-div-26"
                style={{ width: "100%" } }>

                <div
                  id="CardEditDivisionSupplyOrderUX-div-27">
                  {props.saveButton}
                </div>
              </div>
            </FormField>
          </FormGroup>
        </div>
      </div>
    )
}


export default CardEditDivisionSupplyOrderUX

export const screenPropsDefault = {}

/* Date Time : Mon Jul 14 2025 18:18:02 GMT+0700 (Indochina Time)
/* Original screen Data ************************************************************

{
  "elements": [
    {
      "id": 0,
      "name": "div",
      "parent": -1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEditDivisionSupplyOrderUX-div-0"
        },
        "style": {
          "type": "code",
          "value": "{ height:\"100%\",padding:\"10px\"}"
        }
      },
      "seq": 0
    },
    {
      "from": null,
      "id": 1,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "ui form"
        },
        "id": {
          "type": "value",
          "value": "CardEditDivisionSupplyOrderUX-div-1"
        },
        "style": {
          "type": "code",
          "value": "{ marginBottom: \"40px\" }"
        }
      },
      "seq": 1,
      "void": false
    },
    {
      "from": null,
      "id": 2,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardEditDivisionSupplyOrderUX-div-2"
        }
      },
      "seq": 2,
      "void": false
    },
    {
      "from": "react-lib/frameworks/Table",
      "id": 3,
      "name": "Table",
      "parent": 2,
      "props": {
        "className": {
          "type": "value",
          "value": "--rt-tbody-overflow-y-hidden"
        },
        "columns": {
          "type": "code",
          "value": "props.tableHeaders"
        },
        "data": {
          "type": "code",
          "value": "props.supplyOrderList"
        },
        "id": {
          "type": "value",
          "value": "CardEditDivisionSupplyOrderUX-Table-3"
        },
        "minRows": {
          "type": "value",
          "value": "5"
        },
        "onPageChange": {
          "type": "code",
          "value": "props.onPageChange"
        },
        "onPageSizeChange": {
          "type": "code",
          "value": "props.onPageSizeChange"
        },
        "page": {
          "type": "code",
          "value": "props.paginatedItems?.page || 0"
        },
        "pageSize": {
          "type": "code",
          "value": "props.paginatedItems?.pageSize || 0"
        },
        "pages": {
          "type": "code",
          "value": "Math.ceil(props.paginatedItems?.total / props.paginatedItems?.pageSize)"
        },
        "style": {
          "type": "code",
          "value": "{ height: \"calc(95vh - 14.5rem)\"}"
        }
      },
      "seq": 3,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 4,
      "name": "FormGroup",
      "parent": 1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEditDivisionSupplyOrderUX-FormGroup-4"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 4,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 5,
      "name": "FormField",
      "parent": 4,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEditDivisionSupplyOrderUX-FormField-5"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 5,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 6,
      "name": "FormField",
      "parent": 4,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEditDivisionSupplyOrderUX-FormField-6"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 6,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 7,
      "name": "FormField",
      "parent": 4,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEditDivisionSupplyOrderUX-FormField-7"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 7,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 8,
      "name": "FormField",
      "parent": 4,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEditDivisionSupplyOrderUX-FormField-8"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 8,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 9,
      "name": "FormField",
      "parent": 4,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEditDivisionSupplyOrderUX-FormField-9"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 9,
      "void": false
    },
    {
      "from": null,
      "id": 10,
      "name": "div",
      "parent": 5,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardEditDivisionSupplyOrderUX-div-10"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\", display: \"flex\", alignItems: \"center\", gap: \"20px\" } "
        }
      },
      "seq": 10,
      "void": false
    },
    {
      "from": null,
      "id": 11,
      "name": "div",
      "parent": 6,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardEditDivisionSupplyOrderUX-div-11"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\", display: \"flex\", alignItems: \"center\", gap: \"20px\" } "
        }
      },
      "seq": 11,
      "void": false
    },
    {
      "from": null,
      "id": 12,
      "name": "div",
      "parent": 7,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardEditDivisionSupplyOrderUX-div-12"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\", display: \"flex\", alignItems: \"center\", gap: \"20px\" } "
        }
      },
      "seq": 12,
      "void": false
    },
    {
      "from": null,
      "id": 13,
      "name": "div",
      "parent": 8,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardEditDivisionSupplyOrderUX-div-13"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\" } "
        }
      },
      "seq": 13,
      "void": false
    },
    {
      "from": null,
      "id": 14,
      "name": "div",
      "parent": 9,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardEditDivisionSupplyOrderUX-div-14"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\" } "
        }
      },
      "seq": 14,
      "void": false
    },
    {
      "from": null,
      "id": 15,
      "name": "label",
      "parent": 10,
      "props": {
        "children": {
          "type": "value",
          "value": "Date"
        },
        "id": {
          "type": "value",
          "value": "CardEditDivisionSupplyOrderUX-label-15"
        }
      },
      "seq": 15,
      "void": false
    },
    {
      "from": null,
      "id": 16,
      "name": "label",
      "parent": 11,
      "props": {
        "children": {
          "type": "value",
          "value": "HN"
        },
        "id": {
          "type": "value",
          "value": "CardEditDivisionSupplyOrderUX-label-16"
        }
      },
      "seq": 16,
      "void": false
    },
    {
      "from": null,
      "id": 17,
      "name": "label",
      "parent": 12,
      "props": {
        "children": {
          "type": "value",
          "value": "Code"
        },
        "id": {
          "type": "value",
          "value": "CardEditDivisionSupplyOrderUX-label-17"
        }
      },
      "seq": 17,
      "void": false
    },
    {
      "from": null,
      "id": 18,
      "name": "div",
      "parent": 13,
      "props": {
        "children": {
          "type": "code",
          "value": "props.searchButton"
        },
        "id": {
          "type": "value",
          "value": "CardEditDivisionSupplyOrderUX-div-18"
        }
      },
      "seq": 18,
      "void": false
    },
    {
      "from": null,
      "id": 19,
      "name": "div",
      "parent": 14,
      "props": {
        "children": {
          "type": "code",
          "value": "props.clearButton"
        },
        "id": {
          "type": "value",
          "value": "CardEditDivisionSupplyOrderUX-div-19"
        }
      },
      "seq": 19,
      "void": false
    },
    {
      "from": "react-lib/apps/common",
      "id": 20,
      "name": "DateTextBox",
      "parent": 10,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEditDivisionSupplyOrderUX-DateTextBox-20"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeDate"
        },
        "value": {
          "type": "code",
          "value": "props.searchSupplyOrder?.created_date || \"\""
        }
      },
      "seq": 20,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 21,
      "name": "Input",
      "parent": 11,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEditDivisionSupplyOrderUX-Input-21"
        },
        "name": {
          "type": "value",
          "value": "hn"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeData"
        },
        "value": {
          "type": "code",
          "value": "props.searchSupplyOrder?.hn || \"\""
        }
      },
      "seq": 21,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 22,
      "name": "Input",
      "parent": 12,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEditDivisionSupplyOrderUX-Input-22"
        },
        "name": {
          "type": "value",
          "value": "code"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeData"
        },
        "value": {
          "type": "code",
          "value": "props.searchSupplyOrder?.code || \"\""
        }
      },
      "seq": 22,
      "void": false
    },
    {
      "from": null,
      "id": 23,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "ui form"
        },
        "id": {
          "type": "value",
          "value": "CardEditDivisionSupplyOrderUX-div-23"
        },
        "style": {
          "type": "code",
          "value": "{ marginTop: \"20px\" }"
        }
      },
      "seq": 23,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 24,
      "name": "FormGroup",
      "parent": 23,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEditDivisionSupplyOrderUX-FormGroup-24"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{ justifyContent: \"flex-end\" }"
        }
      },
      "seq": 24,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 25,
      "name": "FormField",
      "parent": 24,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEditDivisionSupplyOrderUX-FormField-25"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 25,
      "void": false
    },
    {
      "from": null,
      "id": 26,
      "name": "div",
      "parent": 25,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardEditDivisionSupplyOrderUX-div-26"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\" } "
        }
      },
      "seq": 26,
      "void": false
    },
    {
      "from": null,
      "id": 27,
      "name": "div",
      "parent": 26,
      "props": {
        "children": {
          "type": "code",
          "value": "props.saveButton"
        },
        "id": {
          "type": "value",
          "value": "CardEditDivisionSupplyOrderUX-div-27"
        }
      },
      "seq": 27,
      "void": false
    }
  ],
  "forwardRef": false,
  "height": 80,
  "isMounted": true,
  "name": "CardEditDivisionSupplyOrderUX",
  "project": "CLM CU",
  "screenPropsDefault": {
  },
  "width": 80
}

*********************************************************************************** */
